import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-button-group',
  templateUrl: './form-button-group.component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormButtonGroupComponent extends FieldBaseComponent {
  submit($event: Event) {
    $event.preventDefault();
    this.config?.onSubmit?.(this.formGroup);
    this.fc.validate();
  }
}
